var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSizer || _vm.showElevator
    ? _c("div", { class: _vm.optsClasses }, [
        _vm.showSizer
          ? _c(
              "div",
              { class: _vm.sizerClasses },
              [
                _c(
                  "i-select",
                  {
                    attrs: {
                      size: _vm.size,
                      placement: _vm.placement,
                      transfer: _vm.transfer,
                      disabled: _vm.disabled,
                      eventsEnabled: _vm.eventsEnabled
                    },
                    on: { "on-change": _vm.changeSize },
                    model: {
                      value: _vm.currentPageSize,
                      callback: function($$v) {
                        _vm.currentPageSize = $$v
                      },
                      expression: "currentPageSize"
                    }
                  },
                  _vm._l(_vm.pageSizeOpts, function(item) {
                    return _c(
                      "i-option",
                      {
                        key: item,
                        staticStyle: { "text-align": "center" },
                        attrs: { value: item }
                      },
                      [
                        _vm._v(
                          _vm._s(item) + " " + _vm._s(_vm.t("i.page.page"))
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showElevator
          ? _c("div", { class: _vm.ElevatorClasses }, [
              _vm._v(
                "\n        " + _vm._s(_vm.t("i.page.goto")) + "\n        "
              ),
              _c("input", {
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  spellcheck: "false",
                  disabled: _vm.disabled
                },
                domProps: { value: _vm._current },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changePage.apply(null, arguments)
                  }
                }
              }),
              _vm._v("\n        " + _vm._s(_vm.t("i.page.p")) + "\n    ")
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39d86690", { render: render, staticRenderFns: staticRenderFns })
  }
}